import { Dispatch } from "react";
import { GETAPI } from "../../API/Api";
import {
  GET_CONTEST_LIST_FAIL,
  GET_CONTEST_LIST_SUCCESS,
  GET_CONTEST_LIST_REQUEST,
} from "../../Constants/OrganizationConstant";
import { ApiConfig } from "../../Config/CommonConfig";

export const ContestList = (params: any) => async (dispatch: Dispatch<any>) => {
  try {
    dispatch({ type: GET_CONTEST_LIST_REQUEST });
    let data = await GETAPI(ApiConfig?.ContestList + params, true);

    if (data && data.status === true) {
      dispatch({
        type: GET_CONTEST_LIST_SUCCESS,
        data: data.data,
      });
    } else {
      dispatch({
        type: GET_CONTEST_LIST_FAIL,
        data: [],
      });
    }
  } catch (error) {}
};

// api/organization/list/
